define('api',["jquery", "tokenstorage", "nprogress", "request-context"], function ($, TokenStorage, NProgress, requestContext) {
  var currentRequestsCount = 0;
  var baseUrl = localStorage.getItem("VeggieZoneBaseUrl") || "";
  var softErrorCallback = null;

  var updateProgress = function (inc) {
    if (inc) {
      if (currentRequestsCount === 0) {
        NProgress.start();
      }
      currentRequestsCount++;
    } else {
      currentRequestsCount--;
      if (currentRequestsCount === 0) {
        NProgress.done();
      } else {
        NProgress.inc();
      }
    }
  };
  
  var setCordovaCommonHeaders = function (httpHeaders, token) {
    httpHeaders["X-VeggieZone-Client"] = "Cordova";
    httpHeaders["X-VeggieZone-Platform"] = window.device.platform;
    httpHeaders["X-VeggieZone-PlatformId"] = window.cordova.platformId;
    httpHeaders["X-VeggieZone-DeviceVersion"] = window.device.version;
    httpHeaders["X-VeggieZone-AppVersion"] = window.vzapp.appVersion;
    httpHeaders["X-VeggieZone-AppBuild"] = window.vzapp.appBuild;
    
    if (token) {
      httpHeaders["Authorization"] = "Bearer " + token;
    }
  };

  return {
    contextHeaders: requestContext.headers,

    setBaseUrl: function(url) {
      baseUrl = url || "";
    },
    
    setKnownBaseUrl: function(name) {
        switch(name) {
            case "local":
            baseUrl = "https://fun-urgently-ladybird.ngrok-free.app";
            break;
            
            case "dev":
            baseUrl = "https://dev.veggiezone.cz";
            break;

          case "stage":
            baseUrl = "https://stage.veggiezone.cz";
            break;            
            
            case "prod":
            baseUrl = "https://veggiezone.cz";
            break;
            
            default:
              throw new Error("Unknown base URL name: " + name);
        }
        
        localStorage.setItem("VeggieZoneBaseUrl", baseUrl);
    },
    
    getBaseUrl: function() {
      return baseUrl || "";
    },
    
    setSoftErrorCallback: function (callback) {
      softErrorCallback = callback;
    },
    
    get: function (action, parameters, success, error) {
      return this.call(action, parameters, success, error, "GET");
    },

    post: function (action, data, success, error) {
      return this.call(action, null, success, error, "POST", data);
    },

    delete: function (action, parameters, success, error) {
      return this.call(action, parameters, success, error, "DELETE");
    },

    call: function (action, parameters, success, error, method, rawPostData) {
      var deferred = new $.Deferred();

      parameters = parameters || {};
      
      var contentType = typeof (rawPostData) != "undefined" ? "application/json" : undefined;
      if (rawPostData instanceof Blob || rawPostData instanceof FormData) contentType = false;

      var httpHeaders = {};
      
      TokenStorage.getToken().then(function (token) {
        if(window.cordova) setCordovaCommonHeaders(httpHeaders, token);
        httpHeaders["X-CSRF-TOKEN"] = $("input[name=__RequestVerificationToken]").val();

        updateProgress(true);

        $.ajax(action.indexOf("~/") >= 0 ? action.substr(2) : baseUrl + action, {
          headers: httpHeaders,
          data: rawPostData || parameters,
          contentType: contentType,
          processData: typeof (rawPostData) == "undefined",
          type: method || "POST",
          success: function (data, textStatus, request) {
            updateProgress(false);

            var softError = request.getResponseHeader("x-veggiezone-softerror");
            if (softError) {
              if (typeof softErrorCallback === "function")
                softErrorCallback(softError, request.getResponseHeader("x-veggiezone-softerrorhandlername"), data);

              deferred.reject(softError);
            } else {
              if (success)
                success(data);

              deferred.resolve(data);
            }
          },

          error: function (req, textStatus) {
            updateProgress(false);

            if (error) {
              error(req.status, textStatus, req.responseJSON);
            } else {
              console.error(req.status + " " + textStatus);
            }

            deferred.reject(req.status);
          }
        });
      }).catch(function (error) {
        updateProgress(false);
        deferred.reject(error);
      });

      return deferred.promise();
    },
    
    updateToken: function (token) {
      if(window.cordova) TokenStorage.setToken(token);
      else $("input[name=__RequestVerificationToken]").val(token);
    },
    
    removeToken: function () {
      return new Promise(function (resolve, reject) {
        if(window.cordova) {
          TokenStorage.setToken(null).then(resolve).catch(reject);
        } else {
          resolve();
        }
      });
    },
    
    absoluteUrlToRelative: function (url) {
      if(window.cordova) return url.substr(1);
      
      return url; 
    }
  };
});

